var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9746 17.4377C20.5269 17.4377 20.9746 17.8854 20.9746 18.4377C20.9746 18.99 20.5269 19.4377 19.9746 19.4377H3.97461C3.42232 19.4377 2.97461 18.99 2.97461 18.4377C2.97461 17.8854 3.42232 17.4377 3.97461 17.4377H19.9746ZM19.9746 11.4377C20.5269 11.4377 20.9746 11.8854 20.9746 12.4377C20.9746 12.99 20.5269 13.4377 19.9746 13.4377H3.97461C3.42232 13.4377 2.97461 12.99 2.97461 12.4377C2.97461 11.8854 3.42232 11.4377 3.97461 11.4377H19.9746ZM19.9746 5.43768C20.5269 5.43769 20.9746 5.8854 20.9746 6.43768C20.9746 6.98997 20.5269 7.43768 19.9746 7.43768H3.97461C3.42232 7.43768 2.97461 6.98997 2.97461 6.43768C2.97461 5.8854 3.42232 5.43768 3.97461 5.43768H19.9746Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.62d2cff409f554eaeb932b1ceb6355bf.svg";
export { ForwardRef as ReactComponent };